import { jwtDecode } from 'jwt-decode'
import { useMutation } from 'react-query'
import { useNavigate, useParams } from 'react-router-dom'
import { ROUTES } from 'src/constants'

import AuthDataService from 'src/services/auth.service'

const useResetPassword = () => {
  const { token } = useParams()
  const navigate = useNavigate()

  return useMutation(
    (password: string) => AuthDataService.resetPassword({ password, token: token! }),
    {
      onSettled: (data) => {
        if (!data) return

        if (token) {
          const decodedToken: { journeyRedirect: string } = jwtDecode(token)
          if (decodedToken?.journeyRedirect) {
            navigate(`${ROUTES.LOGIN}/${token}`)
            return
          }
        }

        navigate(ROUTES.LOGIN)
      },
    },
  )
}

export { useResetPassword }
